<template>
  <div class="container">
    <spinner v-if="procesando"></spinner>
    <h4 class="text-primary">Declaración licitud de fondos</h4>
    <div class="col-md-8 col-12">
      <div class="kt-portlet">
        <div class="kt-portlet__body">
          <div class="kt-section">
            <div class="kt-section__content">
              <div class="text-justify">
                Estimado cliente:
                <br><br>
                Antes de continuar con su proceso de pago es importante realizar una aceptación de
                licitud de fondos, por lo que le pedimos tomarse un momento para llenar la siguiente
                declaración.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 order-2 order-md-1">
        <div class="kt-form__section kt-form__section--first" ref="formulario">
          <b-tabs content-class="mt-3" navClass="nav-tabs-line" v-model="tab1">
            <template v-for="(i,ii) in pestanas">
              <b-tab no-body :title="i.titulo" :key="ii" v-if="i.show">
                <template v-slot:title>
                  <md-progress-spinner :md-diameter="11" md-mode="determinate"
                                       :md-value="avance(i)"></md-progress-spinner>
                  {{ i.titulo }}
                </template>
                <b-tabs navClass="nav-tabs-line" v-model="i.pose" v-if="i.tabs.length">
                  <template v-for="(j,jj) in i.tabs">
                    <b-tab no-body :key="jj" v-if="j.show">
                      <template v-slot:title>
                        <i class="fa fa-check text-success" v-if="j.data.complete"></i>{{ j.id }}
                      </template>
                      <datos-personales
                          :solicitante="pestanas[0].tabs[0].data"
                          :formulario="j"
                          :tipo="i"
                          :peps="true"
                          v-if="j.form===1"
                          :lst-tipo-dni="lstTipoDni"
                          :lst-genero="lstGeneros"
                          :lst-nacionalidad="lstNacionalidad"
                          :lst-estado-civil="lstEstado"
                          :lst-provincias="lstProvincia"
                          :lst-tipo-direccion="lstDireccion"
                          :lst-tipo-persona="lstTipoPersona"
                          v-model="j.data"
                          :previos="datosPrevios"
                          :sync="cargandoLst"
                          v-on:cambioEstado="modificarFormEstado"
                          v-on:input="siguiente"
                          v-on:cambioPep="cambioPep"
                          v-on:cambioFam="cambioFam"
                      >
                      </datos-personales>
                      <actividad-economica
                          :identificador="pestanas[1].tabs[0].data.id"
                          :formulario="j"
                          :tipo="i"
                          v-if="j.form===2"
                          :ls-relacion="lstRelacion"
                          :ls-actividad="lstActividad"
                          :ls-provincias="lstProvincia"
                          :ls-pais="lstNacionalidad"
                          :ls-sector="lstSector"
                          v-model="j.data"
                          :previos="datosPrevios"
                          :sync="cargandoLst"
                          v-on:input="siguiente"
                      >
                      </actividad-economica>
                      <situacion-financiera
                          v-if="j.form===3"
                          :conyugue="pestanas[1].tabs[0].data"
                          :validacion="j.config"
                          :formulario="j"
                          :tipo="i"
                          v-model="j.data"
                          :previos="datosPrevios"
                          v-on:input="siguiente"
                      ></situacion-financiera>
                      <referencias
                          :formulario="j"
                          :tipo="i"
                          v-if="j.form===4"
                          v-model="j.data"
                          :previos="datosPrevios"
                          :sync="cargandoLst"
                          v-on:input="siguiente"
                      ></referencias>
                      <autorizacion
                          :tipo="i"
                          :credito="false"
                          v-if="j.form===5"
                          v-model="j.data"
                          :previos="datosPrevios"
                          v-on:input="siguiente"
                      ></autorizacion>
                      <documentos
                          :tipo="i"
                          v-if="j.form===6"
                          v-model="j.data"
                          :previos="datosPrevios"
                          v-on:input="siguiente"
                      ></documentos>
                      <persona-expuesta
                          :formulario="j"
                          :tipo="i"
                          v-if="j.form===7"
                          v-model="j.data"
                          :previos="datosPrevios.elements17?datosPrevios.elements17:[]"
                          :sync="cargandoLst"
                          v-on:input="siguiente"
                      ></persona-expuesta>
                      <familiar-expuesto
                          :formulario="j"
                          :tipo="i"
                          v-if="j.form===8"
                          v-model="j.data"
                          :previos="datosPrevios.elements18?datosPrevios.elements18:[]"
                          :sync="cargandoLst"
                          :lstTipoDni="lstTipoDni"
                          :lstRelacion="lstRelacion"
                          v-on:input="siguiente"
                      ></familiar-expuesto>
                    </b-tab>
                  </template>
                </b-tabs>
              </b-tab>
            </template>
          </b-tabs>
        </div>
      </div>
      <div class="col-md-4 order-1 order-md-2">
        <resumen></resumen>
      </div>
    </div>
  </div>
</template>

<script>
import resumen from "../../../../componentes/resumen-vertical-online";
import datosPersonales from "../../../../componentes/formularios/datosPersonales";
import actividadEconomica from "../../../../componentes/formularios/actividadEconomica";
import situacionFinanciera from "../../../../componentes/formularios/situacionFinanciera";
import {catalogos, persona, negociacion, pagos} from "../../../../servicios";
import referencias from "../../../../componentes/formularios/referencias"
import documentos from "../../../../componentes/formularios/documentos"
import Autorizacion from "../../../../componentes/formularios/autorizacion";
import spinner from "../../../../componentes/spinner";
import PersonaExpuesta from "@/componentes/formularios/persona-expuesta";
import FamiliarExpuesto from "@/componentes/formularios/familiar-expuesto";

export default {
  name: "licitudDeFondos",
  components: {
    FamiliarExpuesto,
    PersonaExpuesta,
    spinner,
    Autorizacion,
    resumen,
    datosPersonales,
    actividadEconomica,
    situacionFinanciera,
    referencias,
    documentos
  },
  data: () => ({
    pestanas: [
      {
        titulo: "Info. solicitante",
        show: true,
        form: 1,
        pose: 0,
        tabs: [
          {
            id: "Datos personales",
            form: 1,
            show: true,
            data: {
              complete: false,
            }
          },
          {
            id: "Datos laborales",
            form: 2,
            show: true,
            data: {
              complete: false
            }
          },
          {
            id: "Situación financiera",
            form: 3,
            show: true,
            config: {
              activos: 1,
              pasivos: 0,
              ingresos: 1,
              gastos: 1
            },
            data: {
              complete: false
            }
          },
          {
            id: "Referencias",
            form: 4,
            show: true,
            data: {
              complete: false
            }
          },
          {
            id: "PEP",
            show: true,
            form: 7,
            data: {
              complete: false
            }
          },
          {
            id: "Familiar expuesto",
            show: true,
            form: 8,
            data: {
              complete: false
            }
          }
        ]
      },
      {
        titulo: "Info. cónyuge",
        show: false,
        form: 2,
        pose: 0,
        tabs: [
          {
            id: "Datos personales",
            form: 1,
            show: true,
            data: {
              id: null,
              complete: false
            }
          },
          {
            id: "Datos laborales",
            form: 2,
            show: true,
            data: {
              complete: false
            }
          },
          {
            id: "Situación financiera",
            form: 3,
            show: true,
            config: {
              activos: 0,
              pasivos: 0,
              ingresos: 1,
              gastos: 0
            },
            data: {
              complete: false
            }
          },
        ]
      },
      {
        titulo: "Documentos",
        show: true,
        form: 3,
        pose: 0,
        tabs: [
          {
            id: "Autorización",
            form: 5,
            show: true,
            data: {
              complete: false
            },
          },
          {
            id: "Archivos",
            form: 6,
            show: true,
            data: {
              complete: false
            },
          }
        ],
      }
    ],
    tab1: 0,
    lstTipoDni: [],
    lstGeneros: [],
    lstNacionalidad: [],
    lstEstado: [],
    lstProvincia: [],
    lstDireccion: [],
    lstCiudad: [],
    lstParroquia: [],
    lstRelacion: [],
    lstActividad: [],
    lstSector: [],
    lstTipoPersona: [],

    datosPrevios: {},

    cargandoLst: false,
    procesando: false,
  }),
  methods: {
    modificarFormEstado: function (estado) {
      this.pestanas[1].show = estado.dt1 === "CASADO" || estado.dt1 === "CASADA";
    },
    cambioPep: function (bandera) {
      this.pestanas[0].tabs[4].show = bandera;
    },
    cambioFam: function (bandera) {
      this.pestanas[0].tabs[5].show = bandera;
    },
    siguiente: function () {
      let vector = [];
      this.pestanas.map((item, index) => {
        if (item.show) {
          item.tabs.map((item2, index2) => {
            if (!item2.data.complete && item2.show) {
              vector.push({tab1: index, tab2: index2});
            }
          })
        }
      });
      if (vector.length) {
        this.tab1 = vector[0].tab1;
        this.pestanas[vector[0].tab1].pose = vector[0].tab2;
      } else {
        this.procesando = true;
        persona.validarDatos().then(() => {
          if (!this.$store.getters.getCotizacion.bdt1) {
            negociacion.validacionDecicionDeCompra().then(() => {
              negociacion.busquedaId();
              this.pagoPrevio();
            }).catch(() => {
              this.procesando = false;
            });
          } else {
            this.pagoPrevio();
          }
        }).catch(() => {
          this.procesando = false;
        });
      }
      let container = this.$refs.formulario;
      container.scrollIntoView();
    },
    pagoPrevio: function () {
      const pago = this.$store.getters.getPago;
      if (pago.tipo.id === 1 && pago.pasarela.name === "p2p") {
        pagos.crearPago(pago.valor, pago.pasarela, pago.tipo).then(r => r.data).then(response => {
          this.procesando = false;
          this.$toast.show(`Redirigiendo`);
          window.location = response.dt1;
        }).catch(() => {
          this.procesando = false;
          this.$router.push({name: pago.tipo.route, query: {tab: pago.tipo.id}});
        });
      } else if (pago.tipo.id === 1) {
        this.procesando = false;
        this.$router.push({name: pago.tipo.route, query: {tab: pago.tipo.id, type: pago.pasarela.name}});
      } else {
        this.procesando = false;
        this.$router.push({name: pago.tipo.route, query: {tab: pago.tipo.id}});
      }
    },
    validar: function (scope) {
      this.$validator.validateAll(scope.id).then((result) => {
        if (result) {
          this.$toast.success(JSON.stringify(scope));
        } else {
          this.$toast.show(`Completa el formulario ` + scope.titulo);
        }
      });
    },
    avance: function (tab) {
      const max = tab.tabs.filter(x=>x.show).length;
      let min = 0;
      tab.tabs.map(i => {
        if (i.data.complete && i.show)
          min++;
      });
      return (min * 100) / max;
    },
    async cargarData() {
      this.cargandoLst = false;
      const [
        tipoPersona,
        generos,
        paises,
        tipoDocumento,
        provincias,
        estados,
        tipoDireccion,
        relacionLaboral,
        tipoActividad,
        sectorLaboral
      ] = await catalogos.lstLicitud();
      this.lstTipoPersona = tipoPersona.data;
      this.lstGeneros = generos.data;
      this.lstNacionalidad = paises.data;
      this.lstTipoDni = tipoDocumento.data.filter(i => i.bdt1 === false);
      this.lstProvincia = provincias.data;
      this.lstEstado = estados.data;
      this.lstDireccion = tipoDireccion.data;
      this.lstRelacion = relacionLaboral.data;
      this.lstActividad = tipoActividad.data;
      this.lstSector = sectorLaboral.data;
      // await persona.datosPersonales().then(r => r.data).then(response => {
      //   this.datosPrevios = response;
      // });
      await persona.datosPersonalesSugerencia().then(r=>r.data).then(response =>{
        this.datosPrevios = response;
      });
      this.cargandoLst = true;
    },
  },
  created() {
    this.cargarData();
  }
}
</script>

<style scoped>

</style>
